import { FilterDatePicker, FilterSelect, SearchField } from '@/modules/common';
import {
  EventOrderStatus,
  EventSmsStatus
} from "@/modules/eventsV2/types";

import {
  type EventFiltersType,
  type FiltersChangeType,
  ChangeTypes
} from "@/modules/eventsV2/hooks";

const statusOptions = [
  { value: 'Sent', id: EventSmsStatus.Sent },
  { value: 'Failed', id: EventSmsStatus.Failed },
];

export const TableFilters = ({
  filters,
  onFilters,
}: {
  filters: EventFiltersType;
  onFilters: FiltersChangeType;
}) => {
  return (
    <div className="flex gap-4">
      <SearchField
        placeholder="Search by phone number"
        defaultValue={filters.search || ''}
        className="w-full min-w-[300px]"
        onChange={(value) => onFilters({ search: value }, ChangeTypes.Debounce)}
      />
      <div className="flex-1">
        <FilterDatePicker
          value={filters.date}
          onChange={(value) => onFilters({ date: value })}
          label="Date"
        />
      </div>
      <div className="flex-1">
        <FilterSelect
          options={statusOptions}
          label="Status"
          value={filters.status}
          onChange={(value: EventOrderStatus) => onFilters({ status: value })}
        />
      </div>
    </div>
  );
};
